var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import 'isomorphic-fetch';
import { canUseDOM } from '@autobest-ui/utils';
export default function xhrAdapter(requestArgs) {
  return __awaiter(this, void 0, void 0, function () {
    var response_1, timer, startTime, response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!requestArgs.setResponseAtRequest) return [3 /*break*/, 2];
          return [4 /*yield*/, requestArgs.setResponseAtRequest(requestArgs)];
        case 1:
          response_1 = _a.sent();
          if (response_1) {
            return [2 /*return*/, Promise.resolve(__assign(__assign({}, response_1), {
              isSetResponseAtRequest: true
            }))];
          }
          _a.label = 2;
        case 2:
          // 未开启过期时间
          if (!requestArgs.timeout || requestArgs.timeout <= 0) {
            return [2 /*return*/, fetch(requestArgs.href, __assign(__assign({}, requestArgs.requestConfig), {
              signal: requestArgs.abortController ? requestArgs.abortController.signal : null
            }))];
          }
          // 客户端超时使用abort
          if (canUseDOM && typeof AbortController !== 'undefined') {
            return [2 /*return*/, new Promise(function (resolve, reject) {
              var controller = requestArgs.abortController || new AbortController();
              var startTime = Date.now();
              var id = setTimeout(function () {
                controller.abort();
              }, requestArgs.timeout);
              fetch(requestArgs.href, __assign(__assign({}, requestArgs.requestConfig), {
                signal: controller.signal
              })).then(function (response) {
                clearTimeout(id);
                resolve(response);
              })["catch"](function (error) {
                clearTimeout(id);
                // 超时，自定义超时返回值
                if (error.name === 'AbortError' && !requestArgs.abortController) {
                  reject({
                    status: 502,
                    code: 502,
                    data: null,
                    stack: error.message,
                    message: "ui request timeout, request limit ".concat(requestArgs.timeout, "ms, time consuming ").concat(Date.now() - startTime, "ms.")
                  });
                  return;
                }
                reject(error);
              });
            })];
          }
          timer = null;
          startTime = Date.now();
          return [4 /*yield*/, Promise.race([fetch(requestArgs.href, __assign(__assign({}, requestArgs.requestConfig), {
            signal: requestArgs.abortController ? requestArgs.abortController.signal : null
          })), new Promise(function (_resolve, reject) {
            timer = setTimeout(function () {
              return reject({
                status: 502,
                code: 502,
                data: null,
                stack: null,
                message: "ui request timeout, request limit ".concat(requestArgs.timeout, "ms, time consuming ").concat(Date.now() - startTime, "ms")
              });
            }, requestArgs.timeout);
          })])];
        case 3:
          response = _a.sent();
          if (timer) {
            clearTimeout(timer);
          }
          return [2 /*return*/, response];
      }
    });
  });
}